import { components, SingleValueProps } from 'react-select';

import { Select, SelectProps } from '../../cdl/Select/Select';
import { Text } from '../../cdl/Text/Text';
import { translate } from '../helpers/translate.helper';

const SortValue = ({ children, ...props }: SingleValueProps) => (
    <components.SingleValue {...props}>
        <Text color="foreground.subtle" marginRight={6}>
            {translate('order.sort')}
        </Text>
        {children}
    </components.SingleValue>
);

export interface SortOption {
    label: string;
    value: {
        sortField: string;
        sortDirection: string;
    };
}

interface SortSelectProps extends Pick<SelectProps<SortOption>, 'onChange'> {
    options: SortOption[];
    value: SortOption;
}

export const SortSelect = (props: SortSelectProps) => {
    return (
        <Select
            value={props.value}
            options={props.options}
            onChange={props.onChange}
            overrides={{ SingleValue: SortValue as any }}
        />
    );
};
